<template>
  <div class="min-h-screen">
    <PageHeader
      :title="tab === 'populations' ? 'Populations' : 'Study Builder'"
      :subtitle="tab === 'populations'
        ? 'Profile a population before studying it: Table 1 + hygiene scan, driven by R'
        : 'Regression-based causal analysis: What influences patient outcomes?'"
      :breadcrumbs="[{ label: 'Insights' }, { label: 'Impact Analytics' }]"
    />
    <div class="p-6 pb-32">

      <PopulationProfiler
        v-if="tab === 'populations'"
        :attributes="attributes"
      />

      <StudyBuilder
        v-else
        :attributes="attributes"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import StudyBuilder from './StudyBuilder.vue';
import PopulationProfiler from './PopulationProfiler.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'Impact_Analytics',
  components: {
    StudyBuilder,
    PopulationProfiler,
    PageHeader,
  },
  props: {
    tab: { type: String, default: 'studies' },
  },
  data() {
    return {
      attributes: [],
    };
  },
  methods: {
    async fetchAttributes() {
      try {
        const response = await axios.get('api/impact_analytics/attributes/');
        this.attributes = response.data;
      } catch (error) {
        console.error('Error fetching attributes:', error);
      }
    },
  },
  mounted() {
    this.fetchAttributes();
  }
};
</script>
